import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import courses from '../data/courses';
import './CourseDetail.css';

const CourseDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const course = courses.find((c) => String(c.id) === String(id));

  if (!course) {
    return (
      <div className="cf-detail-wrapper">
        <div className="cf-detail-card">
          <h2 className="cf-detail-title">Course not found</h2>
          <p className="cf-detail-text">The course you are looking for doesn&apos;t exist.</p>
          <button className="cf-detail-back" onClick={() => navigate('/')}>
            Back to all courses
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="cf-detail-wrapper">
      <div className="cf-detail-card">
        <button className="cf-detail-back-link" onClick={() => navigate(-1)}>
          ← Back to search
        </button>

        {course.imageUrl && (
          <div className="cf-detail-hero-image">
            <img src={course.imageUrl} alt={course.name} />
          </div>
        )}

        <div className="cf-detail-header">
          <div className="cf-detail-heading">
            <h1 className="cf-detail-title">{course.name}</h1>
            <p className="cf-detail-domain">{course.domain}</p>
          </div>
          <div className="cf-detail-tags">
            <span className="cf-detail-pill cf-detail-pill-category">{course.category}</span>
            <span className="cf-detail-pill">{course.level}</span>
          </div>
        </div>

        <p className="cf-detail-text">{course.description}</p>

        <div className="cf-detail-meta">
          <div>
            <span className="cf-detail-meta-label">Duration</span>
            <span className="cf-detail-meta-value">{course.duration}</span>
          </div>
          <div>
            <span className="cf-detail-meta-label">Lessons</span>
            <span className="cf-detail-meta-value">{course.lessons}</span>
          </div>
          <div>
            <span className="cf-detail-meta-label">Language</span>
            <span className="cf-detail-meta-value">{course.language}</span>
          </div>
        </div>

        {course.highlights && course.highlights.length > 0 && (
          <div className="cf-detail-highlights">
            <h2>What you&apos;ll learn</h2>
            <ul>
              {course.highlights.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        )}

        {course.videoUrl && (
          <div className="cf-detail-actions">
            <a
              href={course.videoUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="cf-detail-watch-btn"
            >
              Watch this course on YouTube
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default CourseDetail;


